import {ApplicationState} from '../../redux/state';
import { connect } from 'react-redux';
import ClampexNavigation, { OwnNavigationProps, NavigationProps } from './ClampexNavigation';




function mapStateToProps(state: ApplicationState, ownProps: OwnNavigationProps) :  NavigationProps & OwnNavigationProps {
    return {   
        currentClampexType: state.product.currentProduct.type,    
        navBarButtons: ownProps.navBarButtons,
        title: "KTR Clampex selection - " + state.product.currentProduct.type
    };
}

const ConnectedNavigationWrapper = connect(
    mapStateToProps
)(ClampexNavigation);

export default ConnectedNavigationWrapper;


